import { Injectable } from '@angular/core';
import { filter, take } from 'rxjs/operators';

import { FirstRunSlideModel } from '../first-run/first-run-component/shared/first-run.model';
import { ObservableScope } from '../shared/models/observable-scope.enum';
import { ConfigParserService } from '../shared/services/config-parser.service';
import { EventService } from '../shared/services/event.service';
import { AngularEvents } from '../shared/shared-context/angular-events';
import { CapabilitiesService } from '../shared/shared-context/capabilities.service';

export interface UpsellConfig {
    model: UpsellModel;
    resources: UpsellResources;
}

//TODO: refactor upsell out of FRE
export interface UpsellModel {
    slides: Array<FirstRunSlideModel>;
}

export interface UpsellResources {
    UpsellCloseButtonAriaLabel: string;
    LearnMoreButtonAriaLabel: string;
}

@Injectable({
    providedIn: 'root'
})
export class UpsellConfigService {
    public readonly config: Promise<UpsellConfig>;
    private configPromise: Promise<UpsellConfig>;

    constructor(
        private readonly configParserService: ConfigParserService,
        private readonly capabilitiesService: CapabilitiesService,
        private readonly eventService: EventService
    ) {
    }
    public getConfig(): Promise<UpsellConfig> {
        if (!this.configPromise) {
            const parseConfig = () => this.configParserService.parse<UpsellConfig>('upsellConfig');
            if (this.capabilitiesService.capabilities.pwaEnabled) {
                this.configPromise = Promise.resolve(parseConfig());
            } else {
                const tokensLoadedPromise = this.eventService.events.withScope(ObservableScope.PastAndFuture).pipe(
                    filter(event => event.name === AngularEvents.primaryTokensLoaded),
                    take(1))
                    .toPromise();
                this.configPromise = tokensLoadedPromise.then(() => this.configParserService.parse<UpsellConfig>('upsellConfig'));
            }
        }
        return this.configPromise;
    }
}
